<template>
  <q-page padding class="row justify-center full-height full-width text-center">
    <div class="column flex-center text-center">
      <h4 class="q-my-none">Register</h4>
      <p class="q-my-md">To open an account with us please let us know a few details.</p>
      <form @submit.prevent.stop="register" @reset.prevent.stop="reset" class="q-gutter-y-md" style="width: 300px">
        <q-input v-model="loginFormData.email" type="email" label="Email"
                 class="q-pb-md" outlined
                 hint="Email address associated with the account."
                 ref="emailInput"
                 lazy-rules
                 :rules="[ val => val && val.length > 0 && validateEmail(val) || 'Please enter a valid email address.' ]"/>
        <q-input v-model="loginFormData.companyName" type="text" label="Business/Company Name"
                 class="q-pb-md" outlined
                 ref="companyNameInput"
                 lazy-rules
                 :rules="[ val => val && val.length > 0 || 'Please enter your company\'s name.' ]" />
        <q-input v-model="loginFormData.contactName" type="text" label="Contact Name"
                 class="q-pb-md" outlined
                 ref="contactNameInput"
                 lazy-rules
                 :rules="[ val => val && val.length > 0 || 'Please enter your name.' ]" />
        <q-input v-model="loginFormData.contactPhone" type="tel" label="Phone Number"
                 class="q-pb-md" outlined
                 ref="contactPhoneInput"
                 hint="Best phone number for us to reach you on."
                 lazy-rules
                 :rules="[ val => val && val.length > 0 || 'Please enter your phone number.' ]"/>
        <q-input v-model="loginFormData.ABNACN" type="tel" label="ABN"
                 class="q-pb-md" outlined
                 ref="contactPhoneInput"
                 lazy-rules
                 :rules="[ val => val && val.length > 0 || 'Please enter your ABN or ACN.' ]"/>
        <q-input v-model="loginFormData.shippingAddress" type="textarea" label="Shipping Address"
                 class="q-pb-lg" outlined
                 ref="contactPhoneInput"
                 hint="This is where we'll ship the goods so make sure it's accurate."
                 lazy-rules
                 :rules="[ val => val && val.length > 0 || 'Please enter your shipping address.' ]"/>
        <q-input v-model="loginFormData.password" type="password" label="Password"
                 class="q-pb-md" outlined
                 ref="passwordInput"
                 lazy-rules
                 :rules="[ val => val && val.length > 7 || 'Please enter a password of at least 8 characters.' ]"/>
        <q-input v-model="repeatPassword" type="password" label="Repeat Password"
                 class="q-pb-none" outlined
                 ref="repeatPasswordInput"
                 lazy-rules
                 :rules="[ val => val && val == loginFormData.password || 'Does not match password above.' ]"/>
        <p class="q-mb-none">
          <q-checkbox v-model="agreeTAC" label="I Agree to ICP's" class="q-pr-xs"/>
          <a href="../html-link.htm" target="popup" onclick="window.open('ClimbICP_Website Terms and Conditions_17 June 2019.pdf','name','width=600,height=800')">Terms and Conditions</a>
        </p>
        <p v-show="registerError" class="text-red">
          {{registerErrorMessage}}
        </p>
        <q-btn type="submit" color="primary" class="full-width q-mx-md q-mt-sm q-mb-sm">Register</q-btn>
      </form>
      <p>
        <small><router-link to="/login" class="text-primary">Back To Login</router-link></small>
      </p>
    </div>
  </q-page>
</template>

<script>
import gql from 'graphql-tag'

export default {
  name: 'PageRegister',
  data () {
    return {
      loginFormData: {
        email: '',
        password: '',
        companyName: '',
        ABNACN: '',
        contactName: '',
        contactPosition: '',
        contactPhone: '',
        shippingAddress: ''
      },
      agreeTAC: false,
      repeatPassword: '',
      registerError: false,
      registerErrorMessage: ''
    }
  },
  methods: {
    reset () {
      this.loginFormData.email = ''
      this.loginFormData.password = ''
      this.repeatPassword = ''
      this.loginFormData.companyName = ''
      this.loginFormData.contactPhone = ''
      this.loginFormData.contactName = ''
      this.loginFormData.ABNACN = ''
      this.loginFormData.shippingAddress = ''
      this.agreeTAC = false
      this.clearFormError()
    },
    validateEmail (email) {
      // eslint-disable-next-line no-useless-escape
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    },
    validateForm () {
      this.$refs.emailInput.validate()
      this.$refs.companyNameInput.validate()
      this.$refs.contactNameInput.validate()
      this.$refs.contactPhoneInput.validate()
      this.$refs.passwordInput.validate()
      this.$refs.repeatPasswordInput.validate()
      return !(this.$refs.emailInput.hasError || this.$refs.companyNameInput.hasError ||
        this.$refs.contactNameInput.hasError || this.$refs.contactPhoneInput.hasError ||
        this.$refs.passwordInput.hasError || this.$refs.repeatPasswordInput.hasError)
    },
    setFormError (message) {
      this.registerError = true
      this.registerErrorMessage = message
    },
    clearFormError () {
      this.registerError = false
      this.registerErrorMessage = ''
    },
    trackRegister () {
      let cpy = Object.assign({}, this.loginFormData)
      delete cpy.password // Don't send the password to analytics!!
      // eslint-disable-next-line no-undef
      analytics.track('Register', this.loginFormData)
    },
    async register () {
      if (!this.validateForm()) {
        this.setFormError('Please fix errors above.')
        return
      }
      if (!this.agreeTAC) {
        this.setFormError('Please accept our Terms and and Conditions.')
        return
      }
      try {
        await this.$store.$apollo.mutate({
          mutation: gql`
            mutation ($input: RegisterAccountInput!) {
              register(input: $input) {
                  id,
                  email,
                  roles
              }
          }`,
          variables: {
            input: this.loginFormData
          }
        })
        this.trackRegister()
        this.reset()
        this.$router.push('thanks-for-registering')
      } catch (err) {
        if (err.networkError) {
          this.setFormError('Could not contact server')
        } else if (err.graphQLErrors && err.graphQLErrors.length) {
          this.setFormError(err.graphQLErrors[0].message)
        } else {
          this.setFormError('Error')
        }
      }
    }
  }
}
</script>
